import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

export const CheckboxIcon = <CheckBoxOutlineBlank fontSize="small" />;
export const CheckboxCheckedIcon = <CheckBox fontSize="small" />;
